module.exports = __webpack_public_path__ + "static/media/dot_black_empty.2e23ce7f.svg";